import config from "../../config/apiService.json";
import useData from "./useData";

const {home} = config;
const {views} = home;

const useVisitors = () => {
    const {data, isLoading} = useData(views);
    const { todayCount = 0, weeklyCount = 0, monthlyCount = 0, totalCount = 0 } = data || {};
    const counterList = [
        {title: 'Today', count: todayCount},
        {title: 'This Week', count: weeklyCount},
        {title: 'This Month', count: monthlyCount},
        {title: 'Total', count: totalCount},
    ]

    return {data: counterList, isLoading, };
}

export default useVisitors;
